import React, { MouseEvent } from "react";
import "./Option.css";
import SimpleNumber from "src/components/Input/SimpleNumber/SimpleNumber";
import { toEuroRound } from "src/helpers/calculation";
import Checkbox from "src/components/Input/Checkbox/Checkbox";

interface OptionProps {
  className?: string;
  name: string;
  image: string;
  description: string;
  value: number;
  onChange: (value: number) => void;
  price: number;
}

const OptionNumber: React.FC<OptionProps> = ({
  className,
  image,
  name,
  description,
  value,
  onChange,
  price,
}) => {
  const [state, setState] = React.useState({
    showDetails: false,
  });

  const handleOptionClick = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    // Only +/- buttons and checkbox change selection state, not the item itself
  };

  const toggleDetails = () => {
    setState((prev) => ({ ...prev, showDetails: !prev.showDetails }));
  };

  return (
    <div
      className={`option-container option-number-container has-checkbox ${
        className ?? ""
      } ${value > 0 ? "active" : ""}`}
    >
      <div className="option" onClick={handleOptionClick}>
        <div className="checkbox-left" onClick={(e) => e.stopPropagation()}>
          <Checkbox
            checked={value > 0}
            onChange={(checked) => onChange(checked ? 1 : 0)}
          />
        </div>
        <div className="icon">
          <img src={image} alt={name} />
        </div>
        <span className="name">{name}</span>
        <div className="price">{price > 0 ? toEuroRound(price) : ""}</div>
        {description && (
          <div
            className={`details ${state.showDetails ? "open" : ""}`}
            onClick={(event) => {
              toggleDetails();
              event.stopPropagation();
            }}
          >
            <span>Details</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M12 16L18 10L16.59 8.59L12 13.17L7.41 8.59L6 10L12 16Z"
                fill="#170E0E"
              />
            </svg>
          </div>
        )}
        <div className="components">
          <SimpleNumber
            value={value}
            onChange={onChange}
            min={0}
            max={1000}
            step={1}
          />
        </div>
        {description && state.showDetails && (
          <div className="description">{description}</div>
        )}
      </div>
    </div>
  );
};

export default OptionNumber;
